/*========== NOTIFICATION ACTIONS ============= */

export const getNotifications = (payload) => ({
  type: 'GET_NOTIFICATIONS',
  payload,
});

export const getUnreadCount = () => ({
  type: 'GET_UNREAD_COUNT',
});

export const markAsRead = (payload) => ({
  type: 'MARK_AS_READ',
  payload,
});

export const markAllAsRead = () => ({
  type: 'MARK_ALL_AS_READ',
});

export const archiveNotification = (payload) => ({
  type: 'ARCHIVE_NOTIFICATION',
  payload,
});

export const deleteNotification = (payload) => ({
  type: 'DELETE_NOTIFICATION',
  payload,
});

/*========== PREFERENCE ACTIONS ============= */

export const getNotificationSettings = () => ({
  type: 'GET_NOTIFICATION_SETTINGS',
});

export const getPreferences = () => ({
  type: 'GET_NOTIFICATION_PREFERENCES',
});

export const updatePreferences = (payload) => ({
  type: 'UPDATE_NOTIFICATION_PREFERENCES',
  payload,
});

/*========== SOCKET ACTION ============= */

export const addNewNotification = (payload) => ({
  type: 'ADD_NEW_NOTIFICATION',
  payload,
});
